import React from 'react'
import { useTranslation } from 'react-i18next'

import Picker from '../../../../components/form/Picker'

const UsagePicker = ({ value, onChange }) => {
  const { t } = useTranslation('editChecklist')
  const USAGES_OPTIONS = [
    {
      value: 'form',
      label: t('usageForm')
    },
    {
      value: 'serviceOrder',
      label: t('usageServiceOrder')
    },
    {
      value: 'actionPlan',
      label: t('usageActionPlan')
    }
  ]

  return <Picker options={USAGES_OPTIONS} onChange={onChange} value={value} multiple={true} />
}

export default UsagePicker
